import { trimStart } from "lodash";
import { parse } from "qs";
import { getSearch } from "./global";

/**
 * 获取搜索数据
 */
export function getSearchData(trackData: Record<string, any> = {}) {
  const params = parse(trimStart(location.search, "?"));
  const searchData = getSearch();

  // 优先级设置，不影响原逻辑
  trackData.search_word =
    trackData.search_word || params.q || searchData.search_word;
  trackData.search_word_type = searchData.search_word_type;
  trackData.search_result_number = searchData.search_result_number;
  trackData.search_type = searchData.search_type;
  trackData.filter_ids = searchData.filter_ids || [];
  trackData.original_search_word = searchData.original_search_word;
  trackData.top_label_list = searchData.top_label_list || [];
  trackData.top_label_depth = searchData.top_label_depth || 0;
  trackData.filter_one = trackData.filter_one?.length
    ? trackData.filter_one
    : searchData.filter_one || "";

  return trackData;
}
